import { render, staticRenderFns } from "./gatewayPayment.vue?vue&type=template&id=2f6b26a4"
import script from "./gatewayPayment.vue?vue&type=script&lang=js"
export * from "./gatewayPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports